// Dependencias generales
import React from "react"
import { useEffect } from 'react'

import HeliasLoading1 from '../../../img/helias-loading-01.png'
import HeliasLoading2 from '../../../img/helias-loading-02.png'

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const updateInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/updateInstallationConfiguration"
const putHeliasMonitorCredentials = endpointHelias+'/Helias/V0/Monitor/putHeliasMonitorCredentials'
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"
const lastDashboardDataRequestURL = endpointHelias+'/Helias/V0/General/lastDashboardData'

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js");

// Initial config - FinalStep
const FinalStep = () => {

  useEffect(() => {    

    if(initialConfigCommonJS.antiBackOnboarding() === false){     
      
      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("COMPLETED_USER")
      cargarConfiguracionActualPaso() //Esto también finaliza el registro
      
      localStorage.setItem("showInitialHelp", "true")

      document.title = "HELIAS - Configuración inicial: Creando instalación..."
    }
    
  }, []);

  function cargarConfiguracionActualPaso(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "GeneralInfo": "",
      "Meteo": "",
      "FV": "",
      "Battery": "",
      "Generator": "",
      "Cars": "",
      "Messaging": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{   

            //Si no hay datos configurados entonces no hago nada

            finalizarRegistro()
  
            console.log("Información cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {  
          initialConfigCommonJS.mostrarMensajeInformativo('Se produjo un error al cargar la configuracion.',"negative")
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);      
  }

  function finalizarRegistro(){

    if(initialConfigCommonJS.existeSesion()){

        //Borro en BBDD todas las configuraciones de las opciones no seleccionadas en InstallationElements.
        var elementosNavegacion = localStorage.getItem("customizedWorkflow")
  
        if(elementosNavegacion !== null){
          
          var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
          var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
          var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  

          elementosNavegacion = localStorage.getItem("customizedWorkflow").split(",")         

          //Preparo los datos necesarios para el json
        
          var jsonGuardado = {
            "accountID": localStorage.getItem("accountID"),
            "installationID": ongoingInstallationConfigurationID
          }

          if(elementosNavegacion.indexOf("FV") === -1){jsonGuardado["FV"]=""}
          if(elementosNavegacion.indexOf("BATTERY") === -1){jsonGuardado["Battery"]=""}
          if(elementosNavegacion.indexOf("GENERATOR") === -1){jsonGuardado["Generator"]=""}
          if(elementosNavegacion.indexOf("CARS") === -1){jsonGuardado["Cars"]=""}

          // Guardo la información  
          var xhttp = new XMLHttpRequest();  
          xhttp.open("POST", updateInstallationConfiguration, true);        
          xhttp.setRequestHeader('Content-Type', "application/json");
          xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
          var data = JSON.stringify(jsonGuardado);
          xhttp.onreadystatechange = function() {
            
            if (this.readyState === 4 && this.status === 200) {
              var jsonRespuestaGuardado = JSON.parse(this.responseText)
              if(jsonRespuestaGuardado.statusCode === "403"){                   
                initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
              }
              else{          
                console.log("Información customizedWorkflow actualizada correctamente en BBDD")

                localStorage.setItem("installationId",localStorage.getItem("ongoingInstallationConfiguration"))                                
                var lastAuthUserRefreshToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".refreshToken") 

                //Actualizo las credenciales del monitor
                var xhttp2 = new XMLHttpRequest();
                xhttp2.open("PUT", putHeliasMonitorCredentials, true);        
                xhttp2.setRequestHeader('Content-Type', "application/json");
                xhttp2.setRequestHeader('Authorization', lastAuthUserIdToken);
                var data2 = JSON.stringify({"lastIdToken": lastAuthUserIdToken,"lastRefreshToken": lastAuthUserRefreshToken});
                xhttp2.onreadystatechange = function() {          

                    if (this.readyState === 4 && this.status === 200) {                                  
                        console.log("Actualización de credenciales de MONITOR realizada correctamente.")                          
                  
                        //Primer lanzamiento del monitor de la instalación
                        var xhttp3 = new XMLHttpRequest();
                        xhttp3.open("POST", lastDashboardDataRequestURL, true);        
                        xhttp3.setRequestHeader('Content-Type', "application/json");
                        xhttp3.setRequestHeader('Authorization', lastAuthUserIdToken);
                        var data3 = JSON.stringify({"accountID": localStorage.getItem("accountID"),"installationID": localStorage.getItem("ongoingInstallationConfiguration"),"firstAccess": "true"});
                        xhttp3.onreadystatechange = function() {
       
                            if (this.readyState === 4 && this.status === 200) {                                  

                                var instalacionesActuales = localStorage.getItem("availableInstallations")

                                if ( (instalacionesActuales === null) || (instalacionesActuales === "") ){
                                  instalacionesActuales = localStorage.getItem("ongoingInstallationConfiguration")+"·"+localStorage.getItem("ongoingInstallationName")+"·"+localStorage.getItem("ongoingStepConfiguration")
                                }
                                else{
                                  instalacionesActuales += "|"+localStorage.getItem("ongoingInstallationConfiguration")+"·"+localStorage.getItem("ongoingInstallationName")+"·"+localStorage.getItem("ongoingStepConfiguration")
                                }              
                                
                                localStorage.removeItem("ongoingInstallationName")                        
                                localStorage.setItem("availableInstallations", instalacionesActuales)

                                //window.location.href = "/"           
                                window.location.replace("/");             
                              }            
                              if (this.readyState === 4 && this.status !== 200) {                
                                  console.log("Error en la ejecución de la iteración inicial de la instalación.")      
                                  initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)
                              }            
                          };
                          xhttp3.send(data3);

                    }            
                    if (this.readyState === 4 && this.status !== 200) {                
                        console.log("Error en la inicialización de las credenciales del monitor.")      
                        initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)
                    }            
                };
                xhttp2.send(data2);
              }
            }
      
            if (this.readyState === 4 && this.status !== 200) {                          
              initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
            }

          }
          xhttp.send(data);  
      }
      else{
        initialConfigCommonJS.mostrarMensajeInformativo("No existe información de elementos seleccionados de la instalación, revise la configuración y vuelva a intentarlo.","")
      }
      
    }  
  }

  return (          
    <main>      

      <div className="loader initialcheck">
          <div className="first-loading" >
              <img className="mask" src={HeliasLoading2} alt=""/>
              <img src={HeliasLoading1} alt=""/>
          </div>
          <label id="labelLoaderFinalStep">Dándole los últimos retoques a tu instalación...</label>
      </div>          

    </main>
    
  )
}

export default FinalStep